module.exports = __webpack_public_path__ + "img/sbdw.6384731f.png";